export default function CoralSpringsStickyNav() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-1 md:gap-4 overflow-x-auto py-3 no-scrollbar">
          {[
            { label: "Processing", id: "processing" },
            { label: "Services", id: "services" },
            { label: "About", id: "service-area" },
            { label: "Travel Patterns", id: "travel-timing" },
            { label: "Destinations", id: "destinations" },
            { label: "Facilities", id: "acceptance-facilities" },
            { label: "FAQ", id: "faq" },
            { label: "Resources", id: "local-resources" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs md:text-sm px-3 py-1.5 rounded-full hover:bg-[#F6C344]/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="ml-auto inline-flex items-center gap-1.5 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-xs md:text-sm px-4 py-2 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Start Now <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </nav>
  );
}